/**
 * 会员模块
 */
import http from './http'

export default class VipApi {
    static getVipPrice(params) {
        return http.httpPost('pay/getVipPrice',params);
    }
}



// WEBPACK FOOTER //
// ./app/api/vip.js